import React from 'react';
import Row from '@amzn/meridian/row';
import type { FormRhfControllerProps } from 'src/components/common/forms/types';
import { FormSelect } from 'src/components/common/forms/FormSelect';
import { useTranslation } from 'src/arb-wrapper';
import type { Country } from 'src/store/generated/leela-api-generated';
import { FormLocales } from 'src/components/campaigns/forms/FormLocales';
import { useWatch } from 'react-hook-form';

interface FormLocalizationProps extends FormRhfControllerProps {
  disabled?: boolean;
  disableCountry?: boolean;
  hideCountry?: boolean;
  index: number;
  supportedCountries: Country[];
  supportedLocales: string[];
}

export const FormLocalization: React.FC<FormLocalizationProps> = (props) => {
  const { control, disabled, disableCountry, hideCountry, index, name, supportedCountries, supportedLocales } =
    props;
  const { t } = useTranslation();
  const countryFieldName = `${name}.country`;
  const localesFieldName = `${name}.locales`;
  const selectedCountry = useWatch({ control, name: countryFieldName });

  return (
    <Row alignmentVertical="top" widths="fill">
      {!hideCountry && (
      <FormSelect
        control={control}
        data-testid={`localization-country-${index}`}
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        disabled={disabled || disableCountry}
        label={t('form_country')}
        name={countryFieldName}
        options={supportedCountries.map((country) => ({
          label: country,
          value: country,
        }))}
        placeholder={t('form_country_placeholder')}
        required
      />
      )}

      <FormLocales
        control={control}
        data-testid={`localization-locales-${index}`}
        disabled={disabled === true || selectedCountry === null}
        helperText={t('form_bender_locale_change_warning')}
        name={localesFieldName}
        placeholder={t('form_locales_placeholder')}
        required
        selectedCountry={selectedCountry}
        supportedLocales={supportedLocales}
      />
    </Row>
  );
};
